import Header from '../../../components/Header'
import { HeadingPages } from '../../../components/HeadingPages'
import { Layout } from '../../../components/Layout'
import { Loader } from '../../../components/ComponentLoader/Loader'
import { ErrorBoundary } from 'react-error-boundary'
import InputFloating from '../../../components/InputFloating'
import { useMutation, QueryErrorResetBoundary } from 'react-query'
import { api } from '../../../services/api'
import { Box, Button, Flex, Table, Tbody, Td, Th, Thead, Tr, useToast } from '@chakra-ui/react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import Axios from 'axios'
import { useState } from 'react'

async function fetcher({ numero_pedido }) {
  const response = await api.post(`${process.env.REACT_APP_BASE_URL}/site/v2/crm-controle/listar-controle-imposto`, {
    numero_pedido,
  })

  return response.data
}

const schema = z.object({
  numero_pedido: z.string().min(1, { message: 'Número do pedido é obrigatório' }),
})

export function RelatorioContabilidade() {
  const { handleSubmit, register } = useForm({
    resolver: zodResolver(schema),
  })

  const toast = useToast({
    position: 'top-right',
  })

  const { data, mutateAsync, isLoading } = useMutation({
    mutationFn: fetcher,
    onSuccess: () => {
      console.log('Sucesso')
      toast({
        title: 'Sucesso',
        description: 'Pedido encontrado com sucesso',
        status: 'success',
        duration: 5000,
        isClosable: true,
      })
    },
    onError: () => {
      console.log('Erro')
      toast({
        title: 'Erro',
        description: 'Erro ao encontrar pedido',
        status: 'error',
        duration: 5000,
        isClosable: true,
      })
    },
  })

  async function handleSearch(data) {
    try {
      await mutateAsync({ numero_pedido: data.numero_pedido })
    } catch (error) {
      console.log(error)
    }
  }

  const [loading, setLoading] = useState(false)

  async function generateExcel() {
    if (!data) return
    if (data.length === 0) return

    setLoading(true)

    const header = ['Pedido Compra', 'Pedido Venda']

    const dataItems = data?.map((item) => {
      return {
        pedido_compra: item.pedido_compra ?? '',
        pedido_venda: item.pedido_venda ?? '',
      }
    })

    try {
      const response = await Axios.post(
        'https://apihomolog.innovationbrindes.com.br/node/transform-to-excel',
        {
          header: header,
          data: dataItems,
        },
        { responseType: 'arraybuffer' }
      )

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })

      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `Relatorio-Contabilidade-${new Date()}.xlsx`)
      document.body.appendChild(link)
      link.click()
      link.remove()
    } catch (error) {
      console.log(error)
      setLoading(false)
    }

    setLoading(false)
  }

  return (
    <>
      <HeadingPages name="Relatório Contabilidade" />

      <Layout>
        <Flex gap={2} as="form" onSubmit={handleSubmit(handleSearch)} maxW="550px" w="100%" mx="auto">
          <InputFloating label="Número do pedido" {...register('numero_pedido')} />
          <Button colorScheme="blue" type="submit">
            Buscar
          </Button>
        </Flex>

        {isLoading && <Loader />}

        {data && (
          <QueryErrorResetBoundary>
            {({ reset }) => (
              <ErrorBoundary
                onReset={reset}
                fallbackRender={({ resetErrorBoundary }) => (
                  <Flex>
                    <Button onClick={() => resetErrorBoundary()}>Tentar novamente</Button>
                  </Flex>
                )}
              >
                <Box>
                  <Button colorScheme="green" onClick={generateExcel} isLoading={loading}>
                    Gerar Excel
                  </Button>
                </Box>
                <Table variant="simple" mt="4">
                  <Thead>
                    <Tr bg="gray.100">
                      <Th>Pedido compra</Th>
                      <Th>Pedido venda</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {data?.map((item) => (
                      <Tr key={item.id}>
                        <Td>{item.pedido_compra}</Td>
                        <Td>{item.pedido_venda}</Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </ErrorBoundary>
            )}
          </QueryErrorResetBoundary>
        )}
      </Layout>
    </>
  )
}
